import { render, staticRenderFns } from "./OnboardingCompanyVariablesForm.vue?vue&type=template&id=68b8b4e5"
import script from "./OnboardingCompanyVariablesForm.vue?vue&type=script&lang=js"
export * from "./OnboardingCompanyVariablesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports